import { Toast } from "primereact/toast";
import { createContext, useContext, useRef, useCallback } from "react";

const AppContext = createContext(null);

/**
 * Same idea as Sahas UI: one app-level Toast and `showToast` via context.
 */
export function ProviderAppContainer({ children }) {
    const toastRef = useRef(null);

    const showToast = useCallback((config) => {
        toastRef.current?.show(config);
    }, []);

    return (
        <AppContext.Provider value={{ showToast }}>
            <Toast ref={toastRef} position="top-right" />
            {children}
        </AppContext.Provider>
    );
}

export function useAppContext() {
    const ctx = useContext(AppContext);
    if (!ctx) {
        throw new Error("useAppContext must be used within ProviderAppContainer");
    }
    return ctx;
}
